import {Component, OnInit} from '@angular/core';
import {MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {ConfigurationService} from '../../../../../configuration/configuration.service';
import {MapLayerConfiguration} from '../../../../../shared/models/map-layer.model';
import {FormsModule} from '@angular/forms';
import {MatOption, MatSelect} from '@angular/material/select';
import {MatFormField} from '@angular/material/form-field';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

@Component({
  selector: 'app-choose-layer-dialog',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatFormField,
    MatSelect,
    FormsModule,
    MatOption,
    MatProgressSpinner,
  ],
  templateUrl: './choose-layer-dialog.component.html'
})
export class ChooseLayerDialogComponent implements OnInit {

  mapLayers: MapLayerConfiguration[];
  mapLayer?: MapLayerConfiguration;

  loading = false;

  constructor(private readonly configurationService: ConfigurationService) {
  }

  ngOnInit() {
    this.loading = true;
    this.configurationService.getMapLayersAvailableForPublic()
      .then(layers => {
        this.mapLayers = layers;
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
